export default "__VITE_ASSET__rX5IpSIh__"